import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Input, Button } from 'reactstrap';
import DayPicker from 'react-day-picker';

import './ParkingModel.scss';
import { setBuildingParkingFeeModelCar, setBuildingParkingFeeModelMotorcycle } from '../../actions';
import { AddButton, Card, Dropdown, HeaderSection, Tooltip, validateNumber, InputWithHours, dateYYYYMMDD, Modal, dateDDMMYYYYFormat } from '../../helpers';
import commonConstant from '../../common/_commonConstant';

class ParkingModel extends Component {
  constructor(props) {
    super(props);
    this.state = {      
      'parkingFeeModel': commonConstant.parkingModelType[0],      
      'weekdayTimePeriodType': commonConstant.parkingTimePeriodType[0],
      'weekdayChargeTimePeriodStart': [null],
      'weekdayChargeTimePeriodEnd': [null],
      'weekdayFlatRateNoRedeemFee': [''],
      'weekdayFlatRateRedeemFee': [''],
      'weekdayStepRateNoRedeemFee': [['']],
      'weekdayStepRateAfterNoRedeemFee': [''],
      'weekdayStepRateRedeemFee': [['']],
      'weekdayStepRateAfterRedeemFee': [''],
      'weekendTimePeriodType': commonConstant.parkingTimePeriodType[0],
      'weekendChargeTimePeriodStart': [null],
      'weekendChargeTimePeriodEnd': [null],
      'weekendFlatRateNoRedeemFee': [''],
      'weekendFlatRateRedeemFee': [''],
      'weekendStepRateNoRedeemFee': [['']],
      'weekendStepRateAfterNoRedeemFee': [''],
      'weekendStepRateRedeemFee': [['']],
      'weekendStepRateAfterRedeemFee': [''],
      'customDayAmount': 0,
    };

    this.parkingFeeModel = createRef();
    this.weekdayTimePeriodType = createRef();
    this.weekdayChargeTimePeriodStart = [];
    this.weekdayChargeTimePeriodEnd = [];
    this.weekendTimePeriodType = createRef();
    this.weekendChargeTimePeriodStart = [];
    this.weekendChargeTimePeriodEnd = [];
  }

  componentDidMount() {
    const { buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle, model } = this.props;


    if (buildingParkingFeeModelCar.data || buildingParkingFeeModelMotorcycle.data) {
      this.handleDefaultState();
      if (model === commonConstant.vehicleTypeCar && buildingParkingFeeModelCar.data) {
        this.handleStateData(buildingParkingFeeModelCar.data);  
      } else if (model === commonConstant.vehicleTypeMotorcycle && buildingParkingFeeModelMotorcycle.data) {
        this.handleStateData(buildingParkingFeeModelMotorcycle.data);  
      }
    }    
  }

  componentDidUpdate(prevProps) {
    if (prevProps.model != this.props.model) {
      const { buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle,model } = this.props;     
      this.handleDefaultState();
      if (buildingParkingFeeModelCar.data || buildingParkingFeeModelMotorcycle.data) {
        if (model === commonConstant.vehicleTypeCar && buildingParkingFeeModelCar.data) {
          this.handleStateData(buildingParkingFeeModelCar.data);
        } else if (model === commonConstant.vehicleTypeMotorcycle && buildingParkingFeeModelMotorcycle.data) {
          this.handleStateData(buildingParkingFeeModelMotorcycle.data);   
        }
      }    
    }
  }

  handleDefaultState = () => {
    this.setState({ 
      'parkingFeeModel': commonConstant.parkingModelType[0],      
      'weekdayTimePeriodType': commonConstant.parkingTimePeriodType[0],
      'weekdayChargeTimePeriodStart': [null],
      'weekdayChargeTimePeriodEnd': [null],
      'weekdayFlatRateNoRedeemFee': [''],
      'weekdayFlatRateRedeemFee': [''],
      'weekdayStepRateNoRedeemFee': [['']],
      'weekdayStepRateAfterNoRedeemFee': [''],
      'weekdayStepRateRedeemFee': [['']],
      'weekdayStepRateAfterRedeemFee': [''],
      'weekendTimePeriodType': commonConstant.parkingTimePeriodType[0],
      'weekendChargeTimePeriodStart': [null],
      'weekendChargeTimePeriodEnd': [null],
      'weekendFlatRateNoRedeemFee': [''],
      'weekendFlatRateRedeemFee': [''],
      'weekendStepRateNoRedeemFee': [['']],
      'weekendStepRateAfterNoRedeemFee': [''],
      'weekendStepRateRedeemFee': [['']],
      'weekendStepRateAfterRedeemFee': [''],
      'customDayAmount': 0,
    });

    this.parkingFeeModel = createRef();
    this.weekdayTimePeriodType = createRef();
    this.weekdayChargeTimePeriodStart = [];
    this.weekdayChargeTimePeriodEnd = [];
    this.weekendTimePeriodType = createRef();
    this.weekendChargeTimePeriodStart = [];
    this.weekendChargeTimePeriodEnd = [];
  }

  handleStepRateParkingFeeArray = (stepRateParkingFeeModel) => {
    const arrOfParkingFeeModel = [];    
    if (!stepRateParkingFeeModel) {
      return ['', ''];
    }
    const segments = stepRateParkingFeeModel.split('|');    

    for (const segment of segments) {
      const parkingFeePart = segment.split(':')[1];

      if (parkingFeePart) {
        arrOfParkingFeeModel.push(parkingFeePart);
      } else if (parkingFeePart === '') {
        arrOfParkingFeeModel.push('');
      }
    }
    return arrOfParkingFeeModel;
  }

  handleJsonToData = (data, dayType, parkingFeeModel) => {            
    const timePeriodType = commonConstant.parkingTimePeriodType.filter((parkingTimePeriodType) => parkingTimePeriodType.value === data[0].timePeriodType)[0];    
    const chargeDate = data[0].chargedDate;
    const chargeTimePeriodStart = [];
    const chargeTimePeriodEnd = [];
    const flatRateNoRedeemFee = [];
    const flatRateRedeemFee = [];
    const stepRateNoRedeemFee = [];
    const stepRateAfterNoRedeemFee = [];
    const stepRateRedeemFee = [];
    const stepRateAfterRedeemFee = [];
    const timeStartCreateRef = [];
    const timeEndCreateRef = [];
    

    for (let i = 0; i < data.length; i++) {
      const newData = data[i];
      
      if (timePeriodType.value === 'CUSTOM') {
        newData.chargedTimePeriod.timeStart != null ? chargeTimePeriodStart.push(commonConstant.parkingTimePeriodStart.filter((parkingTimePeriodStart) => parkingTimePeriodStart.value === newData.chargedTimePeriod.timeStart)[0]) : chargeTimePeriodStart.push(null);
        newData.chargedTimePeriod.timeEnd != null ? chargeTimePeriodEnd.push(commonConstant.parkingTimePeriodEnd.filter((parkingTimePeriodEnd) => parkingTimePeriodEnd.value === newData.chargedTimePeriod.timeEnd)[0]) : chargeTimePeriodEnd.push(null);
        timeStartCreateRef.push(createRef());
        timeEndCreateRef.push(createRef());
      }

      if (parkingFeeModel.value === commonConstant.flatRate) {
        newData.feeModel.noRedeem !== '' ? flatRateNoRedeemFee.push(newData.feeModel.noRedeem) : flatRateNoRedeemFee.push('');
        newData.feeModel.redeem !== '' ? flatRateRedeemFee.push(newData.feeModel.redeem) : flatRateRedeemFee.push('');
      }

      if (parkingFeeModel.value === commonConstant.stepRate){
        const arrOfStepRateNoRedeemParkingFeeModel = this.handleStepRateParkingFeeArray(newData.feeModel.noRedeem);
        const arrOfStepRateRedeemParkingFeeModel = this.handleStepRateParkingFeeArray(newData.feeModel.redeem);
        stepRateAfterNoRedeemFee.push(arrOfStepRateNoRedeemParkingFeeModel[arrOfStepRateNoRedeemParkingFeeModel.length - 1]);
        stepRateAfterRedeemFee.push(arrOfStepRateRedeemParkingFeeModel[arrOfStepRateRedeemParkingFeeModel.length - 1]);
        arrOfStepRateNoRedeemParkingFeeModel.pop();
        arrOfStepRateRedeemParkingFeeModel.pop();
        stepRateNoRedeemFee.push(arrOfStepRateNoRedeemParkingFeeModel);
        stepRateRedeemFee.push(arrOfStepRateRedeemParkingFeeModel);
      }
    }

    if (dayType.includes('custom')) {
      this.setState({      
        [`${dayType}Date`] : new Date(chargeDate),
        [`${dayType}ShowCalendar`] : false,
      });
    }

    this.setState({      
      [`${dayType}TimePeriodType`] : timePeriodType,
      [`${dayType}ChargeTimePeriodStart`] : chargeTimePeriodStart.length > 0 ? chargeTimePeriodStart : [null],
      [`${dayType}ChargeTimePeriodEnd`] : chargeTimePeriodEnd.length > 0 ? chargeTimePeriodEnd : [null],
      [`${dayType}FlatRateNoRedeemFee`] : flatRateNoRedeemFee.length > 0 ? flatRateNoRedeemFee : [''],
      [`${dayType}FlatRateRedeemFee`] : flatRateRedeemFee.length > 0 ? flatRateRedeemFee : [''],
      [`${dayType}StepRateNoRedeemFee`] : stepRateNoRedeemFee.length > 0 ? stepRateNoRedeemFee : [['']],
      [`${dayType}StepRateAfterNoRedeemFee`] : stepRateAfterNoRedeemFee.length > 0 ? stepRateAfterNoRedeemFee : [''],
      [`${dayType}StepRateRedeemFee`] : stepRateRedeemFee.length > 0 ? stepRateRedeemFee : [['']],
      [`${dayType}StepRateAfterRedeemFee`] : stepRateAfterRedeemFee.length > 0 ? stepRateAfterRedeemFee : [['']],
    });

    this[`${dayType}ChargeTimePeriodStart`] = timeStartCreateRef;
    this[`${dayType}ChargeTimePeriodEnd`] = timeEndCreateRef;
  }

  handleStateData = (data) => {
    const parseData = JSON.parse(data.parkingFeeModelData);
    const dayModel = parseData.parkingFeeModel.dayModels;
    const customDayModelData = [];
    const parkingFeeModel = commonConstant.parkingModelType.filter((parkingFeeModel) => parkingFeeModel.value === data.parkingFeeModel)[0]; 

    this.handleJsonToData(dayModel.weekday.timePeriods, 'weekday', parkingFeeModel);
    this.handleJsonToData(dayModel.weekend.timePeriods, 'weekend', parkingFeeModel);
    if (dayModel.customDays.timePeriods && dayModel.customDays.timePeriods.length > 0) {
      for (let i = 0; i < dayModel.customDays.timePeriods.length; i++){ 
        customDayModelData.push(dayModel.customDays.timePeriods[i].chargedDate); 
      }

      const newUniqeCustomDayModelData = [...new Set(customDayModelData)];      

      if (newUniqeCustomDayModelData.length > 0) {
        for (let i = 0; i < newUniqeCustomDayModelData.length; i++) {
          this.handleJsonToData(dayModel.customDays.timePeriods.filter((timePeriod) => timePeriod.chargedDate === newUniqeCustomDayModelData[i]), `custom${i + 1}`, parkingFeeModel);
        }
      }

      this.setState({
        'customDayAmount' : newUniqeCustomDayModelData.length,
      });
    }

    this.setState({
      'parkingFeeModel' : parkingFeeModel,        
    });
  }

  handleCheckCanSave = (dayType) => {
    const { parkingFeeModel } = this.state;

    const listOfBool = [];

    if (dayType.includes('custom')){
      this.state[`${dayType}Date`] !== '' ? listOfBool.push(true) : listOfBool.push(false);
    }

    if (this.state[`${dayType}TimePeriodType`].value === 'ALL_DAY') {
      if (parkingFeeModel.value === commonConstant.flatRate) {
        this.state[`${dayType}FlatRateNoRedeemFee`][0] !== '' ? listOfBool.push(true) : listOfBool.push(false);
      } else if (parkingFeeModel.value === commonConstant.stepRate) {
        for (let i = 0; i < this.state[`${dayType}StepRateNoRedeemFee`][0].length; i++) {
          this.state[`${dayType}StepRateNoRedeemFee`][0][i] !== '' ? listOfBool.push(true) : listOfBool.push(false);
        }
        for (let i = 0; i < this.state[`${dayType}StepRateAfterNoRedeemFee`].length; i++) {
          this.state[`${dayType}StepRateAfterNoRedeemFee`][i] !== '' ? listOfBool.push(true) : listOfBool.push(false);
        }
      }
    } else if (this.state[`${dayType}TimePeriodType`].value === 'CUSTOM') {
      if (parkingFeeModel.value === commonConstant.flatRate) {
        for (let i = 0; i < this.state[`${dayType}FlatRateNoRedeemFee`].length; i++) {
          this.state[`${dayType}FlatRateNoRedeemFee`][i] !== '' ? listOfBool.push(true) : listOfBool.push(false);
          this.state[`${dayType}ChargeTimePeriodStart`][i] != null ? listOfBool.push(true) : listOfBool.push(false);
          this.state[`${dayType}ChargeTimePeriodEnd`][i] != null ? listOfBool.push(true) : listOfBool.push(false);
        }
      } else if (parkingFeeModel.value === commonConstant.stepRate) {
        for (let i = 0; i < this.state[`${dayType}StepRateNoRedeemFee`].length; i++) {
          this.state[`${dayType}ChargeTimePeriodStart`][i] != null ? listOfBool.push(true) : listOfBool.push(false);
          this.state[`${dayType}ChargeTimePeriodEnd`][i] != null ? listOfBool.push(true) : listOfBool.push(false);
          for (let j = 0; j < this.state[`${dayType}StepRateNoRedeemFee`][i].length; j++){
            this.state[`${dayType}StepRateNoRedeemFee`][i][j] !== '' ? listOfBool.push(true) : listOfBool.push(false);
          }
          for (let i = 0; i < this.state[`${dayType}StepRateAfterNoRedeemFee`].length; i++) {
            this.state[`${dayType}StepRateAfterNoRedeemFee`][i] !== '' ? listOfBool.push(true) : listOfBool.push(false);
          }
        }
      }
    }

    return listOfBool;
  }

    handleStepRateParkingFeeData = (fee, dayType, type, index) => {
      const feeModelData = [];
      if (fee.length === 1 && fee[0] === '') {
        return null;
      }
      for (let i = 0; i < fee.length; i++) {
        feeModelData.push(`${i + 1}:${fee[i]}`);
      }
      feeModelData.push(`AFTER:${this.state[`${dayType}StepRateAfter${type}Fee`][index]}`);

      return feeModelData.join('|');
    }


    handleSaveParkingModelData = (dayType) => {
      const { parkingFeeModel } = this.state;
      const parkingFeeData = [];
      const periodAmounts = this.handlePeriodAmount(`${dayType}FlatRateNoRedeemFee`, `${dayType}StepRateNoRedeemFee`);      

      if (this.state[`${dayType}TimePeriodType`].value === 'ALL_DAY') {        
        parkingFeeData.push(
          {
            'chargedDate' : dayType.includes('custom') ? dateYYYYMMDD(this.state[`${dayType}Date`]) : null,
            'chargedTimePeriod' : null,
            'feeModel' : {
              'noRedeem' : parkingFeeModel.value === 'FLAT_RATE' ? 
                this.state[`${dayType}FlatRateNoRedeemFee`][0] !== '' ? this.state[`${dayType}FlatRateNoRedeemFee`][0] : null 
                : this.handleStepRateParkingFeeData(this.state[`${dayType}StepRateNoRedeemFee`][0], dayType, 'NoRedeem', 0),
              'redeem' :  parkingFeeModel.value === 'FLAT_RATE' ? this.state[`${dayType}FlatRateRedeemFee`][0] !== '' ? this.state[`${dayType}FlatRateRedeemFee`][0] : null 
                : this.handleStepRateParkingFeeData(this.state[`${dayType}StepRateRedeemFee`][0], dayType, 'Redeem', 0),
            },
            'timePeriodType' : this.state[`${dayType}TimePeriodType`].value,
          },
        );
      } else {
        for (let i = 0; i < periodAmounts; i++) {             
          parkingFeeData.push(
            {
              'chargedDate' : dayType.includes('custom') ? dateYYYYMMDD(this.state[`${dayType}Date`]) : null,
              'chargedTimePeriod' : {
                'timeStart' : this.state[`${dayType}ChargeTimePeriodStart`][i] ? this.state[`${dayType}ChargeTimePeriodStart`][i].value : null,
                'timeEnd' : this.state[`${dayType}ChargeTimePeriodEnd`][i] ? this.state[`${dayType}ChargeTimePeriodEnd`][i].value : null,
              },
              'feeModel' : {
                'noRedeem' : parkingFeeModel.value === 'FLAT_RATE' ? this.state[`${dayType}FlatRateNoRedeemFee`][i] !== '' ? this.state[`${dayType}FlatRateNoRedeemFee`][i] : null 
                  : this.handleStepRateParkingFeeData(this.state[`${dayType}StepRateNoRedeemFee`][i], dayType, 'NoRedeem', i),
                'redeem' :  parkingFeeModel.value === 'FLAT_RATE' ? this.state[`${dayType}FlatRateRedeemFee`][i] !== '' ? this.state[`${dayType}FlatRateRedeemFee`][i] : null 
                  : this.handleStepRateParkingFeeData(this.state[`${dayType}StepRateRedeemFee`][i], dayType, 'Redeem', i),
              },
              'timePeriodType' : this.state[`${dayType}TimePeriodType`].value,
            },
          );
        }
      }
      
      return parkingFeeData;
    }

    handleSaveCustomParkingModelData = () => {
      const { customDayAmount } = this.state;
      const customFeeData = [];

      for (let i = 0; i < customDayAmount; i++) {
        customFeeData.push(...this.handleSaveParkingModelData(`custom${i + 1}`));  
      }

      return customFeeData;
    }

    handleDispatchParkingFeeModel = () => {
      const { parkingFeeModel, customDayAmount } = this.state;
      const { model } = this.props;
      const isCanSave = [];

      isCanSave.push(...this.handleCheckCanSave('weekday'));
      isCanSave.push(...this.handleCheckCanSave('weekend'));

      for (let i = 0; i < customDayAmount; i++) {
        isCanSave.push(...this.handleCheckCanSave(`custom${i + 1}`));  
      }      
      
      if (model === commonConstant.vehicleTypeCar) {
        this.props.dispatch(
          setBuildingParkingFeeModelCar(
            {              
              'isCanSave' : !isCanSave.includes(false),
              'parkingFeeModel' : parkingFeeModel.value,
              'parkingFeeModelData' : JSON.stringify(
                {
                  'parkingFeeModel': {
                    'dayModels' : {
                      'weekday' : {
                        'timePeriods' : this.handleSaveParkingModelData('weekday'),
                      },
                      'weekend' : {
                        'timePeriods' :  this.handleSaveParkingModelData('weekend'),
                      },
                      'customDays' : {
                        'timePeriods' : this.handleSaveCustomParkingModelData(),
                      },
                    },
                  },
                },
              ),
            },
          ),
        );
      } else if (model === commonConstant.vehicleTypeMotorcycle) {        
        this.props.dispatch(
          setBuildingParkingFeeModelMotorcycle(
            {              
              'isCanSave' : !isCanSave.includes(false),
              'parkingFeeModel' : parkingFeeModel.value,
              'parkingFeeModelData' : JSON.stringify(
                {
                  'parkingFeeModel': {
                    'dayModels' : {
                      'weekday' :  {
                        'timePeriods' : this.handleSaveParkingModelData('weekday'),
                      },
                      'weekend' : {
                        'timePeriods' :  this.handleSaveParkingModelData('weekend'),
                      },
                      'customDays' : {
                        'timePeriods' : this.handleSaveCustomParkingModelData(),
                      },
                    },
                  },
                },
              ),
            },
          ),
        );
      }
    }

    handleClearState = () => {
      const { parkingFeeModel, customDayAmount } = this.state;
      const weekdayInputAmount = this.handlePeriodAmount('weekdayFlatRateNoRedeemFee', 'weekdayStepRateNoRedeemFee');
      const weekendInputAmount = this.handlePeriodAmount('weekendFlatRateNoRedeemFee', 'weekendStepRateNoRedeemFee');    

      if (parkingFeeModel.value === commonConstant.stepRate) {        
        const newWeekdayNoRedeemInputAmount = [];
        const newWeekendNoRedeemInputAmount = [];
        const newWeekdayRedeemInputAmount = [];
        const newWeekendRedeemInputAmount = [];

        for (let i = 0; i < weekdayInputAmount; i++) {
          newWeekdayNoRedeemInputAmount.push('');
          newWeekdayRedeemInputAmount.push('');
        }

        for (let i = 0; i < weekendInputAmount; i++) {
          newWeekendNoRedeemInputAmount.push('');
          newWeekendRedeemInputAmount.push('');
        }

        this.setState({
          'weekdayFlatRateNoRedeemFee': newWeekdayNoRedeemInputAmount,
          'weekdayFlatRateRedeemFee': newWeekdayRedeemInputAmount,
          'weekdayStepRateNoRedeemFee': [['']],
          'weekdayStepRateAfterNoRedeemFee': [''],
          'weekdayStepRateRedeemFee': [['']],
          'weekdayStepRateAfterRedeemFee': [''],
          'weekendFlatRateNoRedeemFee': newWeekendNoRedeemInputAmount,
          'weekendFlatRateRedeemFee': newWeekendRedeemInputAmount,
          'weekendStepRateNoRedeemFee': [['']],
          'weekendStepRateAfterNoRedeemFee': [''],
          'weekendStepRateRedeemFee': [['']],
          'weekendStepRateAfterRedeemFee': [''],
        }, () => {this.handleDispatchParkingFeeModel();});
      } else if (parkingFeeModel.value === commonConstant.flatRate) {        
        const newWeekdayNoRedeemInputAmount = [];
        const newWeekendNoRedeemInputAmount = [];
        const newWeekdayRedeemInputAmount = [];
        const newWeekendRedeemInputAmount = [];
        const newWeekdayStepRateAfterNoRedeemFee = [];
        const newWeekendStepRateAfterNoRedeemFee = [];
        const newWeekdayStepRateAfterRedeemFee = [];
        const newWeekendStepRateAfterRedeemFee = [];

        for (let i = 0; i < weekdayInputAmount; i++) {
          newWeekdayNoRedeemInputAmount.push(['']);
          newWeekdayRedeemInputAmount.push(['']);
          newWeekdayStepRateAfterNoRedeemFee.push('');
          newWeekdayStepRateAfterRedeemFee.push('');
        }

        for (let i = 0; i < weekendInputAmount; i++) {
          newWeekendNoRedeemInputAmount.push(['']);
          newWeekendRedeemInputAmount.push(['']);
          newWeekendStepRateAfterNoRedeemFee.push('');
          newWeekendStepRateAfterRedeemFee.push('');
        }


        this.setState({
          'weekdayFlatRateNoRedeemFee': [''],
          'weekdayFlatRateRedeemFee': [''],
          'weekdayStepRateNoRedeemFee': newWeekdayNoRedeemInputAmount,
          'weekdayStepRateAfterNoRedeemFee': newWeekdayStepRateAfterNoRedeemFee,
          'weekdayStepRateRedeemFee': newWeekdayRedeemInputAmount,
          'weekdayStepRateAfterRedeemFee': newWeekdayStepRateAfterRedeemFee,
          'weekendFlatRateNoRedeemFee': [''],
          'weekendFlatRateRedeemFee': [''],
          'weekendStepRateNoRedeemFee': newWeekendNoRedeemInputAmount,
          'weekendStepRateAfterNoRedeemFee': newWeekendStepRateAfterNoRedeemFee,
          'weekendStepRateRedeemFee': newWeekendRedeemInputAmount,
          'weekendStepRateAfterRedeemFee': newWeekendStepRateAfterRedeemFee,
        }, () => {this.handleDispatchParkingFeeModel();});
      }

      if (customDayAmount > 0) {        
        for (let i = 0; i < customDayAmount; i++) {
          const customDayInputAmount = this.handlePeriodAmount(`custom${i + 1}FlatRateNoRedeemFee`, `custom${i + 1}StepRateNoRedeemFee`);
          if (parkingFeeModel.value === commonConstant.stepRate) {        
            const newWeekdayNoRedeemInputAmount = [];
            const newWeekdayRedeemInputAmount = [];
            
        
            for (let i = 0; i < customDayInputAmount; i++) {
              newWeekdayNoRedeemInputAmount.push('');
              newWeekdayRedeemInputAmount.push('');
            }
        
            this.setState({
              [`custom${i + 1}FlatRateNoRedeemFee`]: newWeekdayNoRedeemInputAmount,
              [`custom${i + 1}FlatRateRedeemFee`]: newWeekdayRedeemInputAmount,
              [`custom${i + 1}StepRateNoRedeemFee`]: [['']],
              [`custom${i + 1}StepRateAfterNoRedeemFee`]: [''],
              [`custom${i + 1}StepRateRedeemFee`]: [['']],
              [`custom${i + 1}StepRateAfterRedeemFee`]: [''],           
            }, () => {this.handleDispatchParkingFeeModel();});
          } else if (parkingFeeModel.value === commonConstant.flatRate) {        
            const newWeekdayNoRedeemInputAmount = [];
            const newWeekdayRedeemInputAmount = [];
            const newWeekdayStepRateAfterNoRedeemFee = [];
            const newWeekdayStepRateAfterRedeemFee = [];
            
        
            for (let i = 0; i < customDayInputAmount; i++) {
              newWeekdayNoRedeemInputAmount.push(['']);
              newWeekdayRedeemInputAmount.push(['']);
              newWeekdayStepRateAfterNoRedeemFee.push('');
              newWeekdayStepRateAfterRedeemFee.push('');
            }      
        
            this.setState({
              [`custom${i + 1}FlatRateNoRedeemFee`]: [''],
              [`custom${i + 1}FlatRateRedeemFee`]: [''],
              [`custom${i + 1}StepRateNoRedeemFee`]: newWeekdayNoRedeemInputAmount,
              [`custom${i + 1}StepRateAfterNoRedeemFee`]: newWeekdayStepRateAfterNoRedeemFee,
              [`custom${i + 1}StepRateRedeemFee`]: newWeekdayRedeemInputAmount,
              [`custom${i + 1}StepRateAfterRedeemFee`]: newWeekdayStepRateAfterRedeemFee,        
            }, () => {this.handleDispatchParkingFeeModel();});
          }
        }
      }
    }

    handlePeriodAmount = (flatRateStateName, stepRateStateName) => {
      const { parkingFeeModel } = this.state;

      if (parkingFeeModel.value === commonConstant.flatRate) {
        return this.state[flatRateStateName].length;
      } else if (parkingFeeModel.value === commonConstant.stepRate) {
        return this.state[stepRateStateName].length;
      }
    }

    handleStepRateInput = (value, periodIndex, index, stateName) => {
      let data = [];

      data = [...this.state[stateName]];
      data[periodIndex][index] = value;

      this.setState({
        [stateName]: data,
      }, () => {this.handleDispatchParkingFeeModel();});
    }

    handleRemoveStepRateInput = (periodIndex, stateName, index) => {
      const data = [...this.state[stateName]];

      if (index > -1) {
        data[periodIndex].splice(index, 1); // Removes one element at the specified index
      }
      
      this.setState({
        [stateName]: data,
      }, () => {this.handleDispatchParkingFeeModel();});
    }

    handleAddStepRateInput = (periodIndex, stateName) => {
      const data = [...this.state[stateName]];

      data[periodIndex].push('');

      this.setState({
        [stateName]: data,
      });
    }

    handleParkingFeeInput = (index, type, dayType) => {
      const { parkingFeeModel } = this.state;

      if (parkingFeeModel.value === commonConstant.flatRate) {
        if (type === 'noRedeem') {
          return <div className="parking-fee-input-container">
            <div className="parking-fee-input-label">Flat rate fee</div>
            <Input
              id="building-tax-id"
              className={'template-d'}
              placeholder="Input fee"
              value={this.state[`${dayType}FlatRateNoRedeemFee`][index]}
              onChange={(event) => {
                const value = event.target.value;
                if (validateNumber(value)) {
                  this.handleEventWithIndex(value, `${dayType}FlatRateNoRedeemFee`, index, dayType);
                }
              }}

            />
          </div>;
        } else if (type === 'redeem') {
          return <div className="parking-fee-input-container">
            <div className="parking-fee-input-label">Flat rate fee</div>
            <Input
              id="building-tax-id"
              className={'template-d'}
              placeholder="Input fee"
              value={this.state[`${dayType}FlatRateRedeemFee`][index]}
              onChange={(event) => {
                const value = event.target.value;
                if (validateNumber(value)) {
                  this.handleEventWithIndex(value, `${dayType}FlatRateRedeemFee`, index, dayType);
                }
              }}
            />
          </div>;
        }
      } else if (parkingFeeModel.value === commonConstant.stepRate) {
        if (type === 'noRedeem') {
          return <div className="step-rate-parking-fee-input-container">
            <div className="step-rate-input-container">
              {
                this.state[`${dayType}StepRateNoRedeemFee`][index].map((ele, inputIndex) => (
                  <InputWithHours
                    key={inputIndex}
                    id="search-license-plate"
                    template="a"
                    icon="fas fa-x"
                    placeholder="Input fee"
                    value={ele}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (validateNumber(value)) {
                        this.handleStepRateInput(event.target.value, index, inputIndex, `${dayType}StepRateNoRedeemFee`);
                      }
                    }}
                    number={inputIndex}
                    callback={() => this.handleRemoveStepRateInput(index, `${dayType}StepRateNoRedeemFee`, inputIndex)} 
                    isHideButton={inputIndex === 0 ? true : false}                    
                  />
                ))
              }
              <div>
                <AddButton text="Add step fees" handleOnClick={() => this.handleAddStepRateInput(index, `${dayType}StepRateNoRedeemFee`)} />
              </div>
            </div>
            <div className="step-rate-after-input-container">
              <div className="step-rate-after-input-label">After parking hours fee</div>
              <Input
                id="building-tax-id"
                className={'template-d'}
                placeholder="Input after parking hours fee"
                value={this.state[`${dayType}StepRateAfterNoRedeemFee`][index]}
                onChange={(event) => {
                  const value = event.target.value;
                  if (validateNumber(value)) {
                    this.handleEventWithIndex(value, `${dayType}StepRateAfterNoRedeemFee`, index, dayType);
                  }
                }}

              />
            </div>
          </div>;
        } else if (type === 'redeem') {
          return <div className="step-rate-parking-fee-input-container">
            <div className="step-rate-input-container">
              {
                this.state[`${dayType}StepRateRedeemFee`][index].map((ele, inputIndex) => (
                  <InputWithHours
                    key={inputIndex}
                    id="search-license-plate"
                    template="a"
                    icon="fas fa-x"
                    placeholder="Input fee"
                    value={ele}
                    onChange={(event) => {
                      const value = event.target.value;
                      if (validateNumber(value)) {
                        this.handleStepRateInput(event.target.value, index, inputIndex, `${dayType}StepRateRedeemFee`);
                      }
                    }}
                    number={inputIndex}
                    callback={() => this.handleRemoveStepRateInput(index, `${dayType}StepRateRedeemFee`, inputIndex)} 
                    isHideButton={inputIndex === 0 ? true : false}                 
                  />

                ))
              }
              <div>
                <AddButton text="Add step fees" handleOnClick={() => this.handleAddStepRateInput(index, `${dayType}StepRateRedeemFee`)} />
              </div>
            </div>
            <div className="step-rate-after-input-container">
              <div className="step-rate-after-input-label">After parking hours fee</div>
              <Input
                id="building-tax-id"
                className={'template-d'}
                placeholder="Input after parking hours fee"
                value={this.state[`${dayType}StepRateAfterRedeemFee`][index]}
                onChange={(event) => {
                  const value = event.target.value;
                  if (validateNumber(value)) {
                    this.handleEventWithIndex(value, `${dayType}StepRateAfterRedeemFee`, index, dayType);
                  }
                }}

              />
            </div>
          </div>;
        }
      }
    }

    handleEvent = (event, key, dayType) => {
      this.setState({ [key]: event },
        () => {
          this.handleDispatchParkingFeeModel();
        },
      );      

      if (key === 'parkingFeeModel') {
        this.handleClearState();
        this.parkingFeeModel.current.handleShowItem();
      } else if (key === `${dayType}TimePeriodType`) {
        this[`${dayType}TimePeriodType`].current.handleShowItem();

        const periodAmounts = this.handlePeriodAmount(`${dayType}FlatRateNoRedeemFee`, `${dayType}StepRateNoRedeemFee`);

        if (event.value === 'CUSTOM') {
          for (let i = 0; i < periodAmounts; i++) {
            this[`${dayType}ChargeTimePeriodStart`][i] = createRef();
            this[`${dayType}ChargeTimePeriodEnd`][i] = createRef();
          }
        } else {
          this[`${dayType}ChargeTimePeriodStart`] = [];
          this[`${dayType}ChargeTimePeriodEnd`] = [];

          this.setState({
            [`${dayType}ChargeTimePeriodStart`]: [null],
            [`${dayType}ChargeTimePeriodEnd`]: [null],
          },
          () => {
            this.handleDispatchParkingFeeModel();
          },
          );
        }
      }      
    }

    handleEventWithIndex = (event, key, index, dayType) => {
      const item = [...this.state[key]];
      item[index] = event;
      this.setState({
        [key]: item,
      },
      () => {
        this.handleDispatchParkingFeeModel();
      },
      );

      if (key === `${dayType}ChargeTimePeriodStart`) {
        this[`${dayType}ChargeTimePeriodStart`][index].current.handleShowItem();
      } else if (key === `${dayType}ChargeTimePeriodEnd`) {
        this[`${dayType}ChargeTimePeriodEnd`][index].current.handleShowItem();
      }      
    }

    handleAddCustomTimePeriod = (dayType) => {
      const {
        parkingFeeModel,
      } = this.state;

      const periodAmounts = this.handlePeriodAmount(`${dayType}FlatRateNoRedeemFee`, `${dayType}StepRateNoRedeemFee`);


      if (this.state[`${dayType}TimePeriodType`].value === 'CUSTOM') {
        this.setState({
          [`${dayType}ChargeTimePeriodStart`]: [...this.state[`${dayType}ChargeTimePeriodStart`], null],
          [`${dayType}weekdayChargeTimePeriodEnd`]: [...this.state[`${dayType}ChargeTimePeriodEnd`], null],
        });
        this[`${dayType}ChargeTimePeriodStart`][periodAmounts] = createRef();
        this[`${dayType}ChargeTimePeriodEnd`][periodAmounts] = createRef();
      }

      if (parkingFeeModel.value === commonConstant.flatRate) {
        this.setState({
          [`${dayType}FlatRateNoRedeemFee`]: [...this.state[`${dayType}FlatRateNoRedeemFee`], ''],
          [`${dayType}FlatRateRedeemFee`]: [...this.state[`${dayType}FlatRateRedeemFee`], ''],
        });
      } else if (parkingFeeModel.value === commonConstant.stepRate) {
        this.setState({
          [`${dayType}StepRateNoRedeemFee`]: [...this.state[`${dayType}StepRateNoRedeemFee`], ['']],
          [`${dayType}StepRateRedeemFee`]: [...this.state[`${dayType}StepRateRedeemFee`], ['']],
          [`${dayType}StepRateAfterNoRedeemFee`]: [...this.state[`${dayType}StepRateAfterNoRedeemFee`], ''],
          [`${dayType}StepRateAfterRedeemFee`]: [...this.state[`${dayType}StepRateAfterRedeemFee`], ''],
        });
      }
    }

    handleRemoveCustomTimePeriod = (dayType, periodIndex) => {
      const {
        parkingFeeModel,
      } = this.state;      

      if (parkingFeeModel.value === commonConstant.flatRate) {
        const chargeTimePeriodStart = [...this.state[`${dayType}ChargeTimePeriodStart`]];
        chargeTimePeriodStart.splice(periodIndex, 1);
        const chargeTimePeriodEnd = [...this.state[`${dayType}ChargeTimePeriodEnd`]];
        chargeTimePeriodEnd.splice(periodIndex, 1);
        const flatRateNoRedeemFee = [...this.state[`${dayType}FlatRateNoRedeemFee`]];
        flatRateNoRedeemFee.splice(periodIndex, 1);
        const flatRateRedeemFee = [...this.state[`${dayType}FlatRateRedeemFee`]];
        flatRateRedeemFee.splice(periodIndex, 1);
          
        this.setState({
          [`${dayType}ChargeTimePeriodStart`]: chargeTimePeriodStart,
          [`${dayType}ChargeTimePeriodEnd`]: chargeTimePeriodEnd,
          [`${dayType}FlatRateNoRedeemFee`]: flatRateNoRedeemFee,
          [`${dayType}FlatRateRedeemFee`]: flatRateRedeemFee,
        }, () => {this.handleDispatchParkingFeeModel();});
      } else if (parkingFeeModel.value === commonConstant.stepRate) {
        const chargeTimePeriodStart = [...this.state[`${dayType}ChargeTimePeriodStart`]];
        chargeTimePeriodStart.splice(periodIndex, 1); 
        const chargeTimePeriodEnd = [...this.state[`${dayType}ChargeTimePeriodEnd`]];
        chargeTimePeriodEnd.splice(periodIndex, 1);
        const stepRateNoRedeemFee = [...this.state[`${dayType}StepRateNoRedeemFee`]];
        stepRateNoRedeemFee.splice(periodIndex, 1);
        const stepRateAfterNoRedeemFee = [...this.state[`${dayType}StepRateAfterNoRedeemFee`]];
        stepRateAfterNoRedeemFee.splice(periodIndex, 1);
        const stepRateRedeemFee = [...this.state[`${dayType}StepRateRedeemFee`]];
        stepRateRedeemFee.splice(periodIndex, 1);
        const stepRateAfterRedeemFee = [...this.state[`${dayType}StepRateAfterRedeemFee`]];
        stepRateAfterRedeemFee.splice(periodIndex, 1);
        this.setState({
          [`${dayType}ChargeTimePeriodStart`]:chargeTimePeriodStart,
          [`${dayType}ChargeTimePeriodEnd`]: chargeTimePeriodEnd,
          [`${dayType}StepRateNoRedeemFee`]: stepRateNoRedeemFee,
          [`${dayType}StepRateAfterNoRedeemFee`]: stepRateAfterNoRedeemFee,
          [`${dayType}StepRateRedeemFee`]: stepRateRedeemFee,
          [`${dayType}StepRateAfterRedeemFee`]: stepRateAfterRedeemFee,
        }, () => {this.handleDispatchParkingFeeModel();});
      }
    }

    handleRemoveCustomDay = (dayType) => {
      const { customDayAmount } = this.state;
      const removeCustomDay = dayType.replace('custom', '');
      const intRemoveCustomDay = parseInt(removeCustomDay);
      const newCustomDayAmount = customDayAmount - 1;

      for (let i = intRemoveCustomDay; i < customDayAmount; i++) {
        const nextCustomDay = i + 1;
        this.setState({
          [`custom${i}TimePeriodType`]: this.state[`custom${nextCustomDay}TimePeriodType`],
          [`custom${i}ChargeTimePeriodStart`]: this.state[`custom${nextCustomDay}ChargeTimePeriodStart`],
          [`custom${i}ChargeTimePeriodEnd`]: this.state[`custom${nextCustomDay}ChargeTimePeriodEnd`],
          [`custom${i}FlatRateNoRedeemFee`]: this.state[`custom${nextCustomDay}FlatRateNoRedeemFee`],
          [`custom${i}FlatRateRedeemFee`]: this.state[`custom${nextCustomDay}FlatRateRedeemFee`],
          [`custom${i}StepRateNoRedeemFee`]: this.state[`custom${nextCustomDay}StepRateNoRedeemFee`],
          [`custom${i}StepRateAfterNoRedeemFee`]: this.state[`custom${nextCustomDay}StepRateAfterNoRedeemFee`],
          [`custom${i}StepRateRedeemFee`]:this.state[`custom${nextCustomDay}StepRateRedeemFee`],
          [`custom${i}StepRateAfterRedeemFee`]:this.state[`custom${nextCustomDay}StepRateAfterRedeemFee`],
          [`custom${i}ShowCalendar`]: this.state[`custom${nextCustomDay}ShowCalendar`],
          [`custom${i}Date`]: this.state[`custom${nextCustomDay}Date`],
        });
          
        this[`custom${i}TimePeriodType`] = this[`custom${i}TimePeriodType`];
        this[`custom${i}ChargeTimePeriodStart`] = this[`custom${i}ChargeTimePeriodStart`];
        this[`custom${i}ChargeTimePeriodEnd`] = this[`custom${i}ChargeTimePeriodEnd`];
      }

      this.setState({
        'customDayAmount': newCustomDayAmount,
      }, () => {
        this.handleDispatchParkingFeeModel();
      });      

      

      delete this.state[`custom${customDayAmount}TimePeriodType`];
      delete this.state[`custom${customDayAmount}ChargeTimePeriodStart`];
      delete this.state[`custom${customDayAmount}ChargeTimePeriodEnd`];
      delete this.state[`custom${customDayAmount}FlatRateNoRedeemFee`];
      delete this.state[`custom${customDayAmount}FlatRateRedeemFee`];
      delete this.state[`custom${customDayAmount}StepRateNoRedeemFee`];
      delete this.state[`custom${customDayAmount}StepRateAfterNoRedeemFee`];
      delete this.state[`custom${customDayAmount}StepRateRedeemFee`];
      delete this.state[`custom${customDayAmount}StepRateAfterRedeemFee`];      
      delete this.state[`custom${customDayAmount}ShowCalendar`];
      delete this.state[`custom${customDayAmount}Date`];
      delete this[`custom${customDayAmount}TimePeriodType`];
      delete this[`custom${customDayAmount}ChargeTimePeriodStart`];
      delete this[`custom${customDayAmount}ChargeTimePeriodEnd`];
    }

    handleChargeTimePeriod = (dayType ,index) => <div className="charge-time-period-container">
      <div className="charge-time-period-start-container">
        <Tooltip tooltip="เริ่มตั้งแต่เวลา">
          <span>Charge time period - start</span>
        </Tooltip>
        <div className="charge-time-period-dropdown-container" >
          <Dropdown
            template="b"
            placeholder="Choose start time"
            value={this.state[`${dayType}ChargeTimePeriodStart`][index] && this.state[`${dayType}ChargeTimePeriodStart`][index].label ? this.state[`${dayType}ChargeTimePeriodStart`][index].label : null}
            ref={this[`${dayType}ChargeTimePeriodStart`][index]} >
            <div className="charge-time-period-dropdown-option-container">
              {
                commonConstant.parkingTimePeriodStart.map((ele, parkingTimePeriodIndex) => (
                  <div
                    key={parkingTimePeriodIndex}
                    className={`item${this.state[`${dayType}ChargeTimePeriodStart`][index] && this.state[`${dayType}ChargeTimePeriodStart`][index].value === ele.value ? ' active' : ''}`}
                    onClick={() => this.handleEventWithIndex(ele, `${dayType}ChargeTimePeriodStart`, index, dayType)}
                  >{ele.label}</div>
                ))
              }
            </div>
          </Dropdown>
        </div>

      </div>
      <div className="charge-time-period-end-container">
        <Tooltip tooltip="สิ้นสุดเวลา">
          <span>Charge time period - end</span>
        </Tooltip>
        <div className="charge-time-period-dropdown-container" >
          <Dropdown
            template="b"
            placeholder="Choose start time"
            value={this.state[`${dayType}ChargeTimePeriodEnd`][index] && this.state[`${dayType}ChargeTimePeriodEnd`][index].label ? this.state[`${dayType}ChargeTimePeriodEnd`][index].label : null}
            ref={this[`${dayType}ChargeTimePeriodEnd`][index]} >
            <div className="charge-time-period-dropdown-option-container">
              {
                commonConstant.parkingTimePeriodEnd.map((ele, parkingTimePeriodIndex) => (
                  <div
                    key={parkingTimePeriodIndex}
                    className={`item${this.state[`${dayType}ChargeTimePeriodEnd`][index] && this.state[`${dayType}ChargeTimePeriodEnd`][index].value === ele.value ? ' active' : ''}`}
                    onClick={() => this.handleEventWithIndex(ele, `${dayType}ChargeTimePeriodEnd`, index, dayType)}
                  >{ele.label}</div>
                ))
              }
            </div>
          </Dropdown>
        </div>
      </div>
    </div>

  handleOpenCalendar = (dayType) => {
    this.setState({ [`${dayType}ShowCalendar`]: !this.state[`${dayType}ShowCalendar`] });
  }

  handleSelectDate = (day, dayType) => {
    this.setState({
      [`${dayType}Date`]: day,
    },
    () => {
      this.handleDispatchParkingFeeModel();
    });

    this.handleDispatchParkingFeeModel();
  }

    handleDaySection = (dayType) => {      
      const periodAmounts = this.handlePeriodAmount(`${dayType}FlatRateNoRedeemFee`, `${dayType}StepRateNoRedeemFee`);

      const content = [];

      for (let periodIndex = 0; periodIndex < periodAmounts; periodIndex++) {
        content.push(
          <div>
            <HeaderSection title={`${dayType.charAt(0).toUpperCase() + dayType.slice(1)} ${periodIndex > 0 ? `- custom time period ${periodIndex}` : ''}`} >
              {
                periodIndex > 0 ? <div className="icon fas fa-x" onClick={() => this.handleRemoveCustomTimePeriod(dayType, periodIndex)}/> : null
              }
              {
                (periodIndex === 0) && dayType !== 'weekday' && dayType !== 'weekend' ? <div className="icon fas fa-x" onClick={() => this.handleRemoveCustomDay(dayType)}/> : null
              }
            </HeaderSection>
            {periodIndex === 0 ?
              <div>
                <Tooltip tooltip="คำนวณแบบทั้งวัน หรือแบบช่วงเวลา">
                  <span>Time period type</span>
                </Tooltip>
                <div className="time-period-container">
                  <div>
                    <div className="time-period-dropdown-container" >
                      <Dropdown template="b" value={this.state[`${dayType}TimePeriodType`].label} ref={this[`${dayType}TimePeriodType`]} >
                        {
                          commonConstant.parkingTimePeriodType.map((ele, parkingTimePeriodTypeIndex) => (
                            <div
                              key={parkingTimePeriodTypeIndex}
                              className={`item${this.state[`${dayType}TimePeriodType`] && this.state[`${dayType}TimePeriodType`].value === ele.value ? ' active' : ''}`}
                              onClick={() => this.handleEvent(ele, `${dayType}TimePeriodType`, dayType)}
                            >{ele.label}</div>
                          ))
                        }
                      </Dropdown>
                    </div>
                  </div>
                  {
                    this.state[`${dayType}TimePeriodType`].value === 'CUSTOM' ?
                      <div className="add-custom-time-period-container">
                        <AddButton handleOnClick={() => this.handleAddCustomTimePeriod(dayType)} text="Add custom time period" />
                      </div> : null 
                  }                 
                </div>
              </div>
              : null
            }
            {
              dayType.includes('custom') && periodIndex === 0 ? 
                <div>
                  <div className="custom-date-picker-container">
                    <div className="custom-date-picker-label">Charge date</div>
                    <div className="custom-date-picker" onClick={() => this.handleOpenCalendar(dayType)}>
                      <div>{this.state[`${dayType}Date`] === '' ? ' ' : `${dateDDMMYYYYFormat(this.state[`${dayType}Date`])}`}</div>
                      <div className="icon icon-calendar-1"/>
                    </div>
                  </div>
                  <Modal show={this.state[`${dayType}ShowCalendar`]} className="Modal-CalendarPicker custom-date-picker-calendar">
                    <div className="bg" ref={this.calendar}>
                      <DayPicker
                        month={new Date(new Date().setMonth(new Date().getMonth()))}
                        fromMonth={new Date(new Date().getFullYear(), new Date().getMonth())}
                        toMonth={new Date(new Date().getFullYear(), 11)}
                        selectedDays={[this.state[`${dayType}Date`]]}
                        numberOfMonths={1}
                        // modifiers={{ 'start': from, 'end': to }}
                        onDayClick={(day) => this.handleSelectDate(day, dayType)}
                        renderDay={day => <span id={`date-pickey-${dateYYYYMMDD(new Date(day))}`}>{new Date(day).getDate()}</span>}
                        // navbarElement={this.handlePaginationDatePicker}
                      />
                      <div className="box-btn">                      
                        <Button className="btn-sixtary close" id="btn-close-datepicker" onClick={() => this.handleOpenCalendar(dayType)}>
                          Close
                        </Button>                     
                      </div>
                    </div>
                  </Modal>
                </div>
                : null
            }
            {
              this.state[`${dayType}TimePeriodType`].value === 'CUSTOM' ?
                this.handleChargeTimePeriod(dayType, periodIndex) : null
            }
            <div className="parking-fee-container">
              <div className="parking-fee-header">
                <HeaderSection title={`${dayType.charAt(0).toUpperCase() + dayType.slice(1)} ${periodIndex > 0 ? `- custom time period ${periodIndex}` : ''} - no redeem fee model`} isNoUnderline={true} />
              </div>
              {
                this.handleParkingFeeInput(periodIndex, 'noRedeem', dayType)
              }
              <div className="parking-fee-header">
                <HeaderSection title={`${dayType.charAt(0).toUpperCase() + dayType.slice(1)} ${periodIndex > 0 ? `- custom time period ${periodIndex}` : ''} - redeem fee model (optional)`} isNoUnderline={true} />
              </div>
              {
                this.handleParkingFeeInput(periodIndex, 'redeem', dayType)
              }
            </div>

          </div>,
        );
      }

      return content;
    }

    handleAddCustomDay = () => {
      const { customDayAmount } = this.state; 

      const newCustomDayAmount = customDayAmount + 1;

      this.setState({
        'customDayAmount': newCustomDayAmount,
        [`custom${newCustomDayAmount}TimePeriodType`]: commonConstant.parkingTimePeriodType[0],
        [`custom${newCustomDayAmount}ChargeTimePeriodStart`]: [null],
        [`custom${newCustomDayAmount}ChargeTimePeriodEnd`]: [null],
        [`custom${newCustomDayAmount}FlatRateNoRedeemFee`]: [''],
        [`custom${newCustomDayAmount}FlatRateRedeemFee`]: [''],
        [`custom${newCustomDayAmount}StepRateNoRedeemFee`]: [['']],
        [`custom${newCustomDayAmount}StepRateAfterNoRedeemFee`]: [''],
        [`custom${newCustomDayAmount}StepRateRedeemFee`]: [['']],
        [`custom${newCustomDayAmount}StepRateAfterRedeemFee`]: [''],
        [`custom${newCustomDayAmount}ShowCalendar`]: false,
        [`custom${newCustomDayAmount}Date`]: '',
      });
      
      this[`custom${newCustomDayAmount}TimePeriodType`] = createRef();
      this[`custom${newCustomDayAmount}ChargeTimePeriodStart`] = [];
      this[`custom${newCustomDayAmount}ChargeTimePeriodEnd`] = [];      
    }

    handleCustomDaySection = () => {
      const { customDayAmount } = this.state; 
      
      const content = [];
      if (customDayAmount > 0) {
        for (let i = 0; i < customDayAmount; i++) {
          content.push(
            <div className="custom-day-card-container">
              <Card>
                {
                  this.handleDaySection(`custom${i + 1}`)
                }
              </Card>
            </div>,
          );
        }
      }

      return content; 
    }

    render() {
      const { parkingFeeModel } = this.state;
      const { model } = this.props;
      return (
        <div className="ParkingModel">
          <HeaderSection title="Parking fee model" isHeader={true} />
          <div className="parking-fee-model-container">
            <div className="parking-model-container">
              <div className="parking-fee-model-dropdown-container">
                <div className="parking-fee-model-dropdown-label">
                  <Tooltip tooltip="ลักษณะการจัดเก็บค่าบริการที่จอดรถ">
                    <span>{`${model === commonConstant.vehicleTypeCar ? 'Car' : 'Motorcycle'} parking fee model`}</span>
                  </Tooltip>
                </div>
                <div className="parking-fee-model-dropdown">
                  <Dropdown template="b" placeholder="Choose parking fee model" value={parkingFeeModel ? parkingFeeModel.label : null} ref={this.parkingFeeModel} >
                    {
                      commonConstant.parkingModelType.map((ele, index) => (
                        <div
                          key={index}
                          className={`item${parkingFeeModel && parkingFeeModel.value === ele.value ? ' active' : ''}`}
                          onClick={() => this.handleEvent(ele, 'parkingFeeModel')}
                        >{ele.label}</div>
                      ))
                    }
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="weekday-container">
              <Card>
                {
                  this.handleDaySection('weekday')
                }
              </Card>
            </div>
            <div className="weekend-container">
              <Card>
                {
                  this.handleDaySection('weekend')
                }
              </Card>
            </div>
          </div>
          <div className="custom-day-container">
            <HeaderSection title="Custom day" isHeader={true} >
              <AddButton text="Add custom day" handleOnClick={() => this.handleAddCustomDay()} />
            </HeaderSection>
            {
              this.handleCustomDaySection()
            }
          </div>

        </div>
      );
    }
}

const mapStateToProps = ({ buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle }) => ({ buildingParkingFeeModelCar, buildingParkingFeeModelMotorcycle });

export default connect(mapStateToProps)(ParkingModel);

ParkingModel.propTypes = {
  'model': PropTypes.string,
  'dispatch': PropTypes.func,
  'buildingParkingFeeModelCar': PropTypes.shape({
    'data': PropTypes.shape({}),
  }),
  'buildingParkingFeeModelMotorcycle': PropTypes.shape({
    'data': PropTypes.shape({}),
  }),
};
